<template>
  <div  style="padding:0 100px">
    <h3 style=" text-align: center;">{{ data2.title }}</h3>
    <p class="info" style="padding:0 50px">
      <span>行业制度</span>
      <span>{{ data2.accessNum }} 阅读</span>
      <span>{{ data2.downloadNum }} 下载</span>
      <span>{{ data2.userName }}</span>
      <span>{{ data2.createTime }} 发布</span>
      <el-button
        size="mini"
        @click="download()"
        type="primary"
        v-if="data2.downloadFlag === 1 && permissionList.download"
        >文件下载</el-button
      >
    </p>
    <p style="padding:0 50px">
      {{ data2.content }}
    </p>
    <iframe :src="fileViewUrl" style="width: 100%; height: 800px"></iframe>
  </div>
</template>

<script>
import {
  getKnowledgeProjectSelectById,
  viewKnowledgeProject,
  projectDownload,
} from '@/api/crmedical/knowledge/project';
import urlSettings from '@/config/url-settings';
import { Base64 } from 'js-base64';
import { mapGetters } from 'vuex';

export default {
  props: ['data'],
  data() {
    return {
      data2: {},
      fileViewUrl: '',
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        download: this.vaildData(this.permission.knowledgeprojectfile_dowanload, false),
      };
    },
  },
  created() {
    getKnowledgeProjectSelectById({ id: this.data.id }).then((res) => {
      res.data.accessNum = res.data.accessNum == null ? 0 : res.data.accessNum;
      res.data.downloadNum = res.data.downloadNum == null ? 0 : res.data.downloadNum;
      this.data2 = res.data;
      if (this.data2.link) {
        this.fileViewUrl =
          urlSettings.FILE_VIEW_URL + encodeURIComponent(Base64.encode(this.data2.link));
      }
    });
        let fd = new FormData();
    fd.append('id', this.data.id);
    viewKnowledgeProject(fd).then((res) => {
      console.log('res viewKnowledgeGroup==>', res);
    });
  },
  methods: {
    download() {
      let link = this.data2.link;
      if (!link) return;
      if (link.search('https') == -1) {
        link = link.replace('http', 'https');
      }
      console.log('link==>', link);
      let a = document.createElement('a'); // 创建隐藏的可下载链接
      a.download = link;
      a.style.display = 'none';
      a.href = link;
      document.body.appendChild(a);
      a.click(); // 触发点击
      document.body.removeChild(a);
          let fd = new FormData();
    fd.append('id', this.data.id);
      projectDownload(fd).then((res) => {
        console.log('res projectDownload==>', res);
      }).catch(err=>{
        console.log('err projectDownload==>',err);
      });
    },
  },
};
</script>

<style scoped>
.title {
  text-align: center;
}
.info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>